export { default as CookiePage } from './ui/CookiePage';
